var React = require('react');

function AiAdminAdd (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 1.875C8.37868 1.875 7.875 2.37868 7.875 3V7.875H3C2.37868 7.875 1.875 8.37868 1.875 9C1.875 9.62132 2.37868 10.125 3 10.125H7.875V15C7.875 15.6213 8.37868 16.125 9 16.125C9.62132 16.125 10.125 15.6213 10.125 15V10.125H15C15.6213 10.125 16.125 9.62132 16.125 9C16.125 8.37868 15.6213 7.875 15 7.875L10.125 7.875V3C10.125 2.37868 9.62132 1.875 9 1.875Z","fill":"currentColor"}));
}

AiAdminAdd.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = AiAdminAdd;

AiAdminAdd.default = AiAdminAdd;
